import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2060ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paging_container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"legends\" data-v-7b2060ac><div class=\"legend\" data-v-7b2060ac><div class=\"rectangle\" style=\"background-color:#ffedab;\" data-v-7b2060ac></div><span data-v-7b2060ac>出荷可能在庫＞受注数</span></div><div class=\"legend\" data-v-7b2060ac><div class=\"rectangle\" style=\"background-color:#ffa6a6;\" data-v-7b2060ac></div><span data-v-7b2060ac>出荷可能在庫＜受注数のデータに出荷指示数が設定されています</span></div></div>", 1)
const _hoisted_3 = { class: "OrderOutOfStock_Table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("受注管理"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("年度")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("受注管理"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("No")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow1" }, [
      /*#__PURE__*/_createTextVNode("明細"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("No")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Long1" }, "イベント名称"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow1" }, "取次協会コード"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow1" }, "取引先コード"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Middle2" }, "会社名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("書店"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("番線・"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("仕分")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Area" }, "地区名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Long1" }, "書店名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow1" }, "条件区分"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "条件名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("書誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("版元書誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード①")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Middle2" }, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Title" }, "正式書名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("雑誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "本体価格"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "受注数"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "取置No"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("出荷"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("指示数")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "OrderOutOfStock_Table_Narrow1",
      style: {"z-index":"100"}
    }, " 削除 "),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "正味"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Middle2" }, "短冊備考2"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "登録日"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Middle1" }, "氏名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Middle2" }, "作業備考"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Middle1" }, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStock_Table_Narrow2" }, "出荷可能在庫")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "Text_Left" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "Text_Left" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "Text_Left" }
const _hoisted_16 = { class: "Text_Left" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "Text_Left" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = ["onUpdate:modelValue", "onFocus", "onChange", "onBlur"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "Text_Left" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "Text_Left" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  key: 0,
  class: "ResultMessageNull"
}
const _hoisted_40 = { class: "Footer" }
const _hoisted_41 = {
  key: 1,
  class: "Btn_Disabled",
  style: {"margin-left":"5px"}
}
const _hoisted_42 = { class: "Footer_Download" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 1,
  class: "loading"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "アップロード", -1))

import { ref } from "vue";
import UploadFooter from "../components/UploadFooter.vue";
import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import { useStore } from "vuex";
import axios from "axios";
import Paginate from "vuejs-paginate-next";
import { Notyf } from "notyf";
import * as xlsx from "xlsx";
import { useRoute } from "vue-router";

interface ShinagireList {
  shinagireId: number; //ID
  shinagireYear: string; //受注管理年度
  shinagireNumber: string; //受注管理No
  meisaiId: number; //明細ID
  eventMei: string; //イベント名称
  toritugiCd: string; //取次協会コード
  torihikisakiCd: string; //取引先コード(仮)
  companyName: string; //会社名(仮)
  syotenCd: string; //書店コード
  bansen: string; //番線・仕分
  chikuMei: string; //地区名
  syotenMei: string; //書店名
  joukenKbn: number; //条件区分
  joukenMei: string; //条件名
  syosiCd: string; //基本書誌コード
  yearMonthIssue: number; //年月号・枝
  syomei: string; //書名(仮)
  seisikiSyomei: string; //正式書名(仮)
  oldIsbn: string; //旧ISBN(仮)
  zassiCd: string; //雑誌コード(仮)
  isbn: string; //ISBN
  hontaiPrice: number; //本体価格
  juchuSuu: number; //受注数
  toriokiNumber: string; //取置No
  syukkoSuu: number; //出荷指示数
  syoumi: number; //正味
  syubetuKbn: number; //種目区分
  syubetu: string; //種目区分枝
  hanmotoCd: string; //取引コード
  kenponFlg: number; //献本フラグ(仮)
  client: string; //依頼者
  tanzakuKbn: string; //短冊区分
  tanzakuKbnMei: string; //短冊区分名
  tanzakuRemarks1: string; //短冊備考１
  tanzakuRemarks2: string; //短冊備考２
  updatedBy: string; //更新担当者
  tourokuDate: string; //登録日
  name: string; //氏名(仮)
  hanmotoSyosiCd1: string; //版元書誌コード①(仮)
  hanmotoSyosiCd2: string; //版元書誌コード②(仮)
  companyRemarks: string; //社内備考
  category: string; //カテゴリ
  availableAmount: number; //出荷可能在庫
  zsName: string; //在庫ステータス名
  deleteKbn: number | null; // 削除区分
}

export interface ShowShinagireList extends ShinagireList {
  inputSyukkoSuu: number | string;
  deleteFlg: boolean;
}

interface RegisterPostData {
  shinagireYear: string;
  shinagireNumber: string;
  meisaiId: number;
  syukkoSuu: number;
  deleteKbn: number | null;
  client: string;
  hanmotoCd: string;
  isUpdate: boolean;
}

// OrderHeaderに渡すフラグ--------------------------

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderOutOfStock',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

const store = useStore();
const route = useRoute();
const props = __props;

const notyf = new Notyf();

// ストアの初期化
store.commit("search/clearAuthData");

// 型定義-------------------------------------------
let searchAreaToggle: boolean = true;

//ぱんくずヘッダー
const currentPathList = [{ name: "販売履歴" }, { name: "品切保留" }];
//簡易検索-----------------------------------------
let isActive_KaniFlg = ref(false);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};

//詳細検索-----------------------------------------
let isActive_SyosaiFlg = ref(true);
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

// 検索条件開閉関連---------------------------------
// 開閉時の処理
let isOpentoggleArea = ref<boolean>(true);
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};
//テーブルの高さ判定
const tableHeight = () => {
  if (isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "OrderOutOfStock_TableContainer_Short";
  } else {
    //その他
    return "OrderOutOfStock_TableContainer_Long";
  }
};

// 出荷可能数バリデーション--------------------------------
let holdSyukkoKanousuu = 0;
const holdInputNumber = (e: any, index: number) => {
  holdSyukkoKanousuu = Number(e.target.value);
  search_result.value[index].inputSyukkoSuu = "";
};
const blurInputNumber = (e: any, index: number) => {
  if (e.target.value === "") {
    search_result.value[index].inputSyukkoSuu = holdSyukkoKanousuu;
  }
  holdSyukkoKanousuu = 0;
};
const checkNumber = (e: any, index: number) => {
  //符号無し整数を判定
  const regex = /^[-]?([1-9]\d*|0)$/;
  if (!regex.test(String(search_result.value[index].inputSyukkoSuu))) {
    search_result.value[index].inputSyukkoSuu = 0;
  }
};

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);

// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};

const onClickPage = (newPage: number) => {
  // 未登録のデータがあったらアラート
  let isNotSave = false;
  search_result.value.forEach((search) => {
    // deleteKbn:DBに保存された削除フラグ
    // deleteFlg:フロント制御用削除フラグ
    // 削除フラグON⇒deleteKbn:9,deleteFlg:true
    // 削除フラグOFF⇒deleteKbn:null,deleteFlg:false
    if (
      search.syukkoSuu !== Number(search.inputSyukkoSuu) ||
      (search.deleteKbn === 9 && !search.deleteFlg) ||
      (search.deleteKbn === null && search.deleteFlg)
    ) {
      isNotSave = true;
    }
  });
  let isAccept = false;
  if (isNotSave) {
    isAccept = confirm("未登録のデータが削除されますがよろしいでしょうか？");
  } else {
    isAccept = true;
  }

  if (isAccept) {
    currentPage.value = newPage;
    store.commit("search/setPageNumber", currentPage.value);
    getData();
  }
};

// データ取得---------------------------------------
const search_result = ref([] as ShowShinagireList[]);
const userData = store.getters["login/getUserData"];
let conditions = {} as {
  fromDate: string;
  toDate: string;
  syubetu: string;
  category: string;
  zaikoStatus: string;
  syosiCd: string;
  changeableSyukkoSuu: boolean;
  toritugiCd: string;
  toritugiSyotenCd: string;
};
let params = "";
const getData = async () => {
  search_result.value.splice(0);
  conditions = store.getters["search/getSearchState"];
  params = `hanmotoCd=${userData.hanmotoCd}&userId=${
    userData.userId
  }&freeword=${
    store.getters["search/getEncodeSearchSimpleState"]
  }&fromReleaseDate=${conditions.fromDate}&toReleaseDate=${
    conditions.toDate
  }&syosiCd=${conditions.syosiCd}&changeable=${
    conditions.changeableSyukkoSuu
  }&syubetu=${conditions.syubetu}&categoryCd=${String(
    conditions.category
  )}&zaikoStatus=${conditions.zaikoStatus}&toritugiCd=${
    conditions.toritugiCd
  }&toritugiSyotenCd=${conditions.toritugiSyotenCd}&page=${
    store.getters["search/getPageNumber"]
  }&numberOfDisplay=${dataPerPage}`;
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/orderOutOfStock/display?${params}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    res.data.mstShinagire.forEach((shinagire: ShinagireList) => {
      search_result.value.push({
        inputSyukkoSuu: shinagire.syukkoSuu,
        deleteFlg: shinagire.deleteKbn === null ? false : true,
        ...shinagire,
      });
    });

    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    getTotalPage();
  } catch (error) {
    alert("データを取得できませんでした");
    console.log(error);
  }
};
// 在庫照会のテーブル内リンクから遷移した場合はcreated時にgetDataを呼ばない（searchSimple経由で呼ぶため）
if (route.query.syosiCd === undefined) getData();

//検索処理
const onSearch = (): void => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  getData();
};

// 登録処理-----------------------------------------------
const onRegister = async () => {
  const postData = [] as RegisterPostData[];
  search_result.value.forEach((search) => {
    postData.push({
      shinagireYear: search.shinagireYear,
      shinagireNumber: search.shinagireNumber,
      meisaiId: search.meisaiId,
      syukkoSuu: Number(search.inputSyukkoSuu),
      deleteKbn: search.deleteFlg ? 9 : null,
      client: userData.username,
      hanmotoCd: userData.hanmotoCd,
      isUpdate:
        search.syukkoSuu !== Number(search.inputSyukkoSuu) ||
        (search.deleteKbn === 9 && !search.deleteFlg) ||
        (search.deleteKbn === null && search.deleteFlg)
          ? true
          : false,
    });
  });

  try {
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/orderOutOfStock/shinagireKaijo`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    // 登録後データを再取得
    getData();
    notyf.success("登録しました");
  } catch (error) {
    notyf.error("データが登録できませんでした");
    console.log(error);
  }
};

// ダウンロード-------------------------------------------------------
let isDownloading = ref(false);
const getExcelData = async () => {
  isDownloading.value = true;
  let state = store.getters["search/getSearchState"];
  let downloadParams = `hanmotoCd=${userData.hanmotoCd}&userId=${
    userData.userId
  }&freeword=${
    store.getters["search/getEncodeSearchSimpleState"]
  }&fromReleaseDate=${state.fromDate}&toReleaseDate=${state.toDate}&syosiCd=${
    state.syosiCd
  }&changeable=${state.changeableSyukkoSuu}&syubetu=${
    state.syubetu
  }&categoryCd=${String(state.category)}&zaikoStatus=${
    state.zaikoStatus
  }&toritugiCd=${state.toritugiCd}&toritugiSyotenCd=${
    state.toritugiSyotenCd
  }&page=${
    store.getters["search/getPageNumber"]
  }&numberOfDisplay=${dataPerPage}`;
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/orderOutOfStock/shinagire.xlsx?${downloadParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    downloadFile(res);
  } catch (error) {
    isDownloading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};

const downloadFile = (resData: any) => {
  //   let bom = new Uint8Array([0xef, 0xbb, 0xbf]); //文字化け対策
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  // parseSheet(resData.data, "品切保留リスト");

  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `品切保留_${getTimeStamp()}.xlsx`;
  link.click();
  isDownloading.value = false;
};

const getTimeStamp = () => {
  const dt = new Date();
  const Y = dt.getFullYear();
  const M = ("00" + (dt.getMonth() + 1)).slice(-2);
  const D = ("00" + dt.getDate()).slice(-2);
  return Y + M + D;
};

// 【テスト】ダウンロードしたExcelのヘッダーを取得
// フォームで入力されたExcelのsheetNameシートをオブジェクトにする。
// let headerArray = [];
// const parseSheet = (file) => {
//   console.log("parse");

//   // Uint8Arrayに詰め替え
//   const data = new Uint8Array(file);
//   // xlsxファイルの読み込み
//   const workbook = xlsx.read(data, { type: "array", cellStyles: true });
//   const sheetName = workbook.SheetNames[0];
//   console.log(workbook.Sheets[sheetName]);
// };
// アップロード-------------------------------------------------------
const inputFile = ref();
const onClick = () => {
  //「アップロード」ボタンを押下すると非表示中のinput=fileが発火する
  inputFile.value.click();
};
const resetFile = (e: any) => {
  e.target.value = "";
};
const uploadFile = (e: any) => {
  const FILE = e.target.files[0];
  const READER = new FileReader();

  READER.onload = async (e: any) => {
    const Utils = xlsx.utils; // XLSX.utilsのalias
    // ブラウザからのファイルリード結果を変数に保存
    let DATA = e.target.result;
    let arr = fixdata(DATA);
    let wb;
    wb = xlsx.read(btoa(arr), {
      type: "base64",
      cellDates: true,
    });

    // wbの空セルがundefinedになるため空文字を入れる
    const sheetNames = wb.SheetNames;
    const workSheet = wb.Sheets[sheetNames[0]];

    // セルの範囲
    const range = workSheet["!ref"];
    if (range !== undefined) {
      // セル範囲を数値表現に変換
      const decodeRange = Utils.decode_range(range as string);

      for (
        let rowIndex = decodeRange.s.r;
        rowIndex <= decodeRange.e.r;
        rowIndex++
      ) {
        for (
          let colIndex = decodeRange.s.c;
          colIndex <= decodeRange.e.c;
          colIndex++
        ) {
          // 数値表現をセルアドレス ("A1"など) に変換
          const address = Utils.encode_cell({ r: rowIndex, c: colIndex });
          let cell = workSheet[address];

          if (typeof cell === "undefined" || typeof cell.v === "undefined") {
            workSheet[address] = { t: "s", v: "", w: "" };
          }
        }
      }
      wb.Sheets[sheetNames[0]] = workSheet;
      // xlsx.writeFile(wb)
    }
    // ---------------------------------------

    let JSON: { [anyKey: string]: any } = {};
    JSON = file_to_json(wb);

    //ファイルバリデーション
    const error = hasFileError(JSON);
    if (error.hasError) {
      notyf.error(error.message);
      return;
    }

    //コード区分・商品コード・数量のキーを書き換え
    const sheetName = Object.keys(JSON)[0];
    JSON = JSON[sheetName].map((e: { [x: string]: any }) => ({
      shinagireYear: e["受注管理年度"],
      shinagireNumber: e["受注管理No"],
      meisaiId: e["明細No"],
      syukkoSuu: e["出荷指示数"] === "" ? 0 : e["出荷指示数"],
      deleteKbn: e["削除区分"] === "" ? null : e["削除区分"],
      client: userData.username,
      hanmotoCd: userData.hanmotoCd,
    }));

    try {
      const res = await axios.post(
        `${store.getters["getBaseUrl"]}/orderOutOfStock/uploadExcel`,
        JSON,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (res.status === 204) {
        notyf.success("登録が完了しました");
        //カート再取得
        getData();
      }
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.data.userMessage) {
        // console.log(error.response?.status);
        notyf.error({
          duration: 10000,
          message: e.response?.data.userMessage,
        });
      }
      console.log(e);
    }
  };
  // Fileオブジェクトバイナリデータとしてメモリ上に読み込む（読み込んだらonload部分を実行する）
  READER.readAsArrayBuffer(FILE);
};

//EXCELファイルの読み込み
const fixdata = (DATA: any) => {
  let o = "",
    l = 0,
    w = 10240;
  for (; l < DATA.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(DATA.slice(l * w, l * w + w)) as any
    );
  o += String.fromCharCode.apply(
    null,
    new Uint8Array(DATA.slice(l * w)) as any
  );
  return o;
};

//読み込んだファイルをJSONへ変換
// ワークブックのデータをjsonに変換
const file_to_json = (workbook: xlsx.WorkBook) => {
  var result: { [anyKey: string]: any } = {};
  workbook.SheetNames.forEach(function (sheetName: string | number) {
    var roa = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName], {
      raw: true,
    });
    if (roa.length > 0) {
      result[sheetName] = roa;
    }
  });
  return result;
};

const keys = ["受注管理年度", "受注管理No", "明細No", "出荷指示数", "削除区分"];
const hasFileError = (JSON: { [anyKey: string]: any }) => {
  let error = {
    hasError: false,
    message: "",
  };

  const sheetName = Object.keys(JSON)[0];
  if (!JSON[sheetName]) {
    error.hasError = true;
    error.message = "ファイル内にデータがありません";
    return error;
  }

  //シートにデータが無ければ中断
  const firstFileJSON = JSON[sheetName];
  if (!firstFileJSON.length) {
    error.hasError = true;
    error.message = "ファイル内にデータがありません";
    return error;
  }

  //シートのヘッダに特定のキーが含まれていないものは中断;
  keys.forEach((key) => {
    if (!Object.keys(firstFileJSON[0]).includes(key)) {
      error.hasError = true;
      error.message = "フォーマットが異なっているためアップロード出来ません";
    }
  });
  if (error.hasError) {
    return error;
  }

  // 出庫指示数と削除区分のバリデーション
  firstFileJSON.forEach((row: any) => {
    if (
      (row["削除区分"] !== "" && row["削除区分"] !== 9) ||
      !(String(row["出荷指示数"]).match(/^[0-9]+$/) || row["出荷指示数"] === "")
    ) {
      error.hasError = true;
      error.message =
        "削除区分または出荷指示数の入力に誤りがあるためアップロード出来ません";
    }
  });
  return error;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["OrderOutOfStock", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
    }, [
      _createVNode(PankuzuHeader, {
        isActive_SidebarFlg: props.isActive_SidebarFlg,
        currentPathList: currentPathList
      }, null, 8, ["isActive_SidebarFlg"]),
      _createVNode(OrderHeader, {
        isActive_SidebarFlg: props.isActive_SidebarFlg,
        isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
        isActive_KaniFlg: _unref(isActive_KaniFlg),
        searchAreaToggle: _unref(searchAreaToggle),
        onChangeKaniFlg: changeKaniFlg,
        onChangeSyosaiFlg: changeSyosaiFlg,
        onOnSearch: onSearch,
        onChangeToggleArea: changeToggleArea
      }, null, 8, ["isActive_SidebarFlg", "isActive_SyosaiFlg", "isActive_KaniFlg", "searchAreaToggle"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, search_result.value.length]
        ]),
        _hoisted_2
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["OrderOutOfStock_TableContainer", tableHeight()])
      }, [
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          (search_result.value.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (result, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({
              'bg-orange': result.availableAmount >= result.juchuSuu,
              'bg-red':
                result.availableAmount < result.juchuSuu &&
                Number(result.inputSyukkoSuu) > 0,
            })
                  }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(result.shinagireYear), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(result.shinagireNumber), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(result.meisaiId), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(result.eventMei), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(result.toritugiCd), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(result.torihikisakiCd), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(result.companyName), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(result.syotenCd), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(result.bansen), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(result.chikuMei), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(result.syotenMei), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(result.joukenKbn), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(result.joukenMei), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(result.syosiCd), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(result.hanmotoSyosiCd1), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(result.isbn), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(result.seisikiSyomei), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(result.zassiCd), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(result.hontaiPrice), 1),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(result.juchuSuu), 1),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(result.toriokiNumber), 1),
                    _createElementVNode("td", _hoisted_27, [
                      (
                  result.availableAmount > 0 &&
                  result.availableAmount >= result.juchuSuu
                )
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            class: "OrderOutOfStock_Table_Input",
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((result.inputSyukkoSuu) = $event),
                            onFocus: ($event: any) => (holdInputNumber($event, index)),
                            onChange: ($event: any) => (checkNumber($event, index)),
                            onBlur: ($event: any) => (blurInputNumber($event, index))
                          }, null, 40, _hoisted_28)), [
                            [_vModelText, result.inputSyukkoSuu]
                          ])
                        : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(result.inputSyukkoSuu), 1))
                    ]),
                    _createElementVNode("td", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((result.deleteFlg) = $event)
                      }, null, 8, _hoisted_31), [
                        [_vModelCheckbox, result.deleteFlg]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(result.syoumi), 1),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(result.tanzakuRemarks2), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(result.tourokuDate), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(result.name), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(result.companyRemarks), 1),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(result.category), 1),
                    _createElementVNode("td", _hoisted_38, _toDisplayString(result.availableAmount), 1)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (!search_result.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, " ※検索結果はありません "))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_40, [
      (search_result.value.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: onRegister,
            class: "Footer_RegisterButton"
          }, " 登録 "))
        : (_openBlock(), _createElementBlock("button", _hoisted_41, "登録")),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", {
          class: _normalizeClass(["Footer_Download_Btn", { Footer_Download_Disabled: _unref(isDownloading) }]),
          onClick: getExcelData,
          disabled: _unref(isDownloading)
        }, [
          (!_unref(isDownloading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isDownloading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_44))
            : _createCommentVNode("", true),
          _hoisted_45
        ], 10, _hoisted_43),
        _createElementVNode("input", {
          onChange: uploadFile,
          onClick: resetFile,
          type: "file",
          ref_key: "inputFile",
          ref: inputFile,
          accept: ".xlsx",
          style: {"display":"none"}
        }, null, 544),
        _createElementVNode("button", {
          onClick: onClick,
          class: "Footer_Download_Btn",
          style: {"margin-left":"10px"}
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "upload",
            style: {"display":"inline-block"}
          }),
          _hoisted_46
        ])
      ])
    ])
  ], 64))
}
}

})